import { SimpleGrid, Container, Text, Box, Stack } from "@chakra-ui/react";

export const AboutMe = () => (
  <>
    <Text
      fontSize={{ base: "11px", md: "md" }}
      color="rgb(148 163 184)"
      textAlign="justify"
      as="i"
    >
      I am a software engineer based in Amsterdam, the Netherlands.
    </Text>
  </>
);
